(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["press-coverage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializePressCoverage = (root) => {
      if (!root || root.dataset.pressCoverageReady === 'true') return;

      root.dataset.pressCoverageReady = 'true';

      const buttons = Array.from(root.querySelectorAll('[data-press-filter]'));
      const cards = Array.from(root.querySelectorAll('[data-press-card]'));

      if (!buttons.length || !cards.length) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const applyFilter = (filter) => {
        buttons.forEach((button) => {
          const isActive = button.dataset.pressFilter === filter;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });

        cards.forEach((card) => {
          card.hidden = filter !== 'all' && card.dataset.category !== filter;
        });
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const update = () => applyFilter(button.dataset.pressFilter);

          if (document.startViewTransition && !reduceMotion) {
            document.startViewTransition(update);
          } else {
            update();
          }
        });
      });
    };

    document.querySelectorAll('[data-press-coverage]').forEach(initializePressCoverage);

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches('[data-press-coverage]')
        ? event.target
        : event.target.querySelector('[data-press-coverage]');

      initializePressCoverage(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
